// API base URL configuration
// Reads from Vite env var VITE_API_BASE_URL; defaults to local backend.
export const API_BASE_URL = (import.meta?.env?.VITE_API_BASE_URL?.trim?.() || 'http://localhost:9876').replace(/\/$/, '')

// Builds a full URL ensuring exactly one slash between base and path
export function apiUrl(path = '') {
    const p = String(path || '')
    return `${API_BASE_URL}${p.startsWith('/') ? '' : '/'}${p}`
}
